import React, { useState } from 'react';

const About = () => {
  const [showMap, setShowMap] = useState(false);

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Sección Historia del Hotel con Video */}
        <div className="mb-20 bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-0">
            {/* Columna izquierda: Texto */}
            <div className="p-8 md:p-12 flex flex-col justify-center order-2 md:order-1">
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
                Hotel Montecarlo
              </h2>
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p className="font-normal">
                  Hotel Montecarlo, inaugurado el 10 de diciembre de 2002, nació como un proyecto familiar que mantiene un sello cercano, acogedor y de confianza. Ubicado en pleno centro de la ciudad, ofrece cómodas habitaciones, atención personalizada y un ambiente tranquilo. Su patio interior con una agradable cascada invita al descanso y desconexión. Además, recibe empresas, ejecutivos y jefaturas, siendo ideal para viajes laborales. Un hotel familiar que combina calidez, experiencia y versatilidad.
                </p>
              </div>
            </div>

            {/* Columna derecha: Video */}
            <div className="h-64 md:h-auto relative overflow-hidden order-1 md:order-2">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
                style={{ objectFit: 'cover' }}
              >
                <source
                  src="https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/jeyfh5i3_hotel.mp4"
                  type="video/mp4"
                />
                Tu navegador no soporta el video.
              </video>
            </div>
          </div>
        </div>

        {/* Sección Región de Atacama */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="p-6 md:p-12 flex flex-col justify-center">
              <h3 className="text-2xl md:text-3xl font-bold text-blue-900 mb-4">
                Región de Atacama
              </h3>
              <p className="text-gray-700 leading-relaxed text-base md:text-lg">
                La tercera región le da la bienvenida y le invita a ver los contrastes más 
                diversos de la naturaleza: montañas, playas, dunas, parques nacionales, lagos 
                y extensos salares del altiplano, valles y desiertos. Descubre desde el 
                Desierto de Atacama, el más árido del mundo, hasta las cristalinas aguas de 
                Bahía Inglesa, uno de los destinos turísticos más reconocidos a nivel nacional.
              </p>
            </div>
            <div 
              className="h-64 md:h-auto relative overflow-hidden cursor-pointer group rounded-r-2xl"
              onMouseEnter={() => setShowMap(true)}
              onMouseLeave={() => setShowMap(false)}
            >
              <img
                src="https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/yiaqv7xe_mar%20de%20dunas.jpg"
                alt="Mar de Dunas - Región de Atacama"
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                  showMap ? 'opacity-0' : 'opacity-100'
                }`}
              />
              <img
                src="https://customer-assets.emergentagent.com/job_hotel-redesign-1/artifacts/d5ejzfda_482369354_18305637352227163_2685922669603219788_n.jpg"
                alt="Mapa Turístico Región de Atacama"
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                  showMap ? 'opacity-100' : 'opacity-0'
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
